import React, { useState, useEffect } from 'react';
import './CardGrid.css';

const CardGrid = ({ onCardClick, onEasterEgg, onOpenDrawingBoard }) => {
  const [konami, setKonami] = useState([]);
  const [lastClickTime, setLastClickTime] = useState(0);
  const [rapidClicks, setRapidClicks] = useState(0);

  // Código Konami: ↑↑↓↓←→←→BA
  const konamiCode = [
    'ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown',
    'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight',
    'KeyB', 'KeyA'
  ];

  useEffect(() => {
    const handleKeyPress = (e) => {
      const newKonami = [...konami, e.code];
      if (newKonami.length > konamiCode.length) {
        newKonami.shift();
      }
      setKonami(newKonami);

      if (JSON.stringify(newKonami) === JSON.stringify(konamiCode)) {
        onEasterEgg("🎮 Vale por elegir el videojuego de la noche - ¡Código Konami desbloqueado!");
        setKonami([]);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [konami, onEasterEgg]);

  const handleCardDoubleClick = (card) => {
    const currentTime = Date.now();
    if (currentTime - lastClickTime < 300) {
      setRapidClicks(prev => prev + 1);
      if (rapidClicks >= 2) {
        onEasterEgg("⚡ Vale por elegir la película de la noche - ¡Click rapidísimo!");
        setRapidClicks(0);
      }
    } else {
      setRapidClicks(0);
    }
    setLastClickTime(currentTime);
    onCardClick(card);
  };

  // 12 razones más especiales con temática gótica tierna
  const cards = [
    { 
      id: 1, 
      title: "#1", 
      type: "normal", 
      image: "/images/1.png", 
      description: "Eres una buena compañia, haces feliz a cualquier persona que pase el día contigo, tienes un aura muy agradable mi negra." 
    },
    
    { 
      id: 2, 
      title: "#2", 
      type: "normal", 
      images: ["/images/mascotas1.jpeg", "/images/mascotas2.jpg", "/images/mascotas3.jpeg", "/images/mascotas4.jpeg"],
      description: "Amas mucho a tus mascotas, los cuidas, les das cariño y siempre estás ahí para ellos."
    },
    
    { 
      id: 3, 
      title: "#3", 
      type: "normal", 
      images: ["/images/estudio1.jpeg", "/images/estudio2.jpeg",],
      description: "Eres muy inteligente y estudiosa, me da gusto verte estudiar y un poco de risa verte renegar porque haces todo en los grupos XD." 
    },
    
    { 
      id: 4, 
      title: "#4", 
      type: "normal", 
      image: "/images/terca.jpeg", 
      description: "Eres muy sensible, y me gusta ser tu lugar seguro cuando mas lo necesitas, Asumes tus errores (no siempre jeje) y siempre buscas soluciones a todo."
    },
    
    { 
      id: 5, 
      title: "#5", 
      type: "normal", 
      image: "/images/melosa.jpeg", 
      description: "Eres muy amorosa conmigo, siempre sabes cómo hacerme sentir especial con tus besitos y abrazos." 
    },
    
    { 
      id: 6, 
      title: "#6", 
      type: "normal", 
      images: ["/images/tragacion.jpeg", "/images/tragacion2.jpeg", "/images/tragacion3.jpeg","/images/tragacion4.jpeg", "/images/tragacion5.jpeg", "/images/tragacion6.jpeg"],
      description: "Me encanta que seas mi compañera de tragación, compañera de grasa, compañera de obesidad morbida." 
    },
    
    { 
      id: 7, 
      title: "#7", 
      type: "normal", 
      images: ["/images/tono1.jpeg","/images/tono2.jpeg"],
      description: "Toneamos rico, se nos ve lindo como pareja, eres mi complemento perfecto."
    },
    
    { 
      id: 8, 
      title: "#8", 
      type: "normal", 
      images: ["/images/linda1.jpeg","/images/linda2.jpeg","/images/linda3.jpeg","/images/linda4.jpeg","/images/linda5.jpeg"],    
      description: "Eres muy autentica, siempre te mantienes fiel a ti misma y no tienes miedo de mostrar tu verdadero yo, además, estas preciosa carajo, la mujer mas linda c:." 
    },
    
    { 
      id: 9, 
      title: "#9", 
      type: "normal", 
      images: ["/images/final1.png","/images/final3.jpeg"],
      description: "Eres un mate de risa, cada que nos juntamos, tenemos que llorar de la risa almenos una vez. te amo demasiado, por cierto, el dibujo fue solo una pista XD, mira la pizarra, te hice un paint jeje, o sea, imagina decir, mi novio me programo un paint XD, bueno, si necesitas algun pincel personalizado, o alguna otra funcion, solo dimelo y lo programo mailov."
    },
    
  ];

  return (
    <div className="card-grid-container">
      <div className="card-grid-wrapper">
        <div className="card-grid">
          {cards.map((card) => (
            <div
              key={card.id}
              className="card"
              onClick={() => handleCardDoubleClick(card)}
            >
              <div className="card-content">
                <h3 className="card-title">{card.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Botón de Zona de Dibujos fuera del escalado */}
      <div className="drawing-board-section">
        <button 
          className="drawing-board-btn"
          onClick={onOpenDrawingBoard}
        >
          <span>Zona de Dibujos</span>
        </button>
      </div>
    </div>
  );
};

export default CardGrid;
